import Moderator from '@/models/bread/Moderator/couponPlan'

export default {
  key:'CouponPlan',
  server:'sso',
  name:{
    singular:'Plan',
    plural:'Plans',
  },
  parents:[
    'Coupon',
  ],
  Admin:false,
  Moderator:Moderator,
  Teacher:false,
}